// @flow
import type { ApiExecutorType } from 'types/ApiExecutorType';
import type { ContactFormType, SingleContactFormType } from 'types/ContactForm7';

import {
  convertFormContactResponseFromApi,
  convertFormContactFromApi,
  convertOneFormContactFromApi,
  convertSingleFormContactFromApi
} from 'services/ContactForm7';
import { FORM_CONTACT_TOKEN } from 'constants/api';

function ContactForm7Api(executor: ApiExecutorType) {
  return { postFormContact, fetchFirstFormContact, fetchSingleCF7FormContact, fetchAllFormContact };

  function fetchFirstFormContact(): Promise<ContactFormType> {
    return executor
      .get(`/contact-form-7/v1/contact-forms/`, {
        withCredentials: false,
        headers: {
          Authorization: `Basic ${FORM_CONTACT_TOKEN}`
        }
      })
      .then(response => convertFormContactFromApi(response));
  }

  function fetchSingleCF7FormContact(id: number): Promise<SingleContactFormType> {
    return executor
      .get(`/contact-form-7/v1/contact-forms/${id}`, {
        withCredentials: false,
        headers: {
          Authorization: `Basic ${FORM_CONTACT_TOKEN}`
        }
      })
      .then(response => convertSingleFormContactFromApi(response));
  }

  function fetchAllFormContact(): Promise<ContactFormType> {
    return executor
      .get(`/contact-form-7/v1/contact-forms/`, {
        withCredentials: false,
        headers: {
          Authorization: `Basic ${FORM_CONTACT_TOKEN}`
        }
      })
      .then(response => Promise.all(response.map(convertOneFormContactFromApi)));
  }

  function postFormContact(formInputs: any, id: number) {
    return executor
      .post(`/contact-form-7/v1/contact-forms/${id}/feedback`, formInputs, {
        withCredentials: false,
        headers: {
          Authorization: `Basic ${FORM_CONTACT_TOKEN}`,
          'content-type': 'multipart/form-data'
        },
        timeout: 6000000
      })
      .then(response => convertFormContactResponseFromApi(response));
  }
}
export default ContactForm7Api;
